export default {
  inheritAttrs: false,
  props: {
    value: {
      type: [Number, String],
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    pre: {
      type: String,
      default: ''
    },
    post: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: ''
    },
    outlined: {
      type: Boolean,
      default: false
    },
    allowDecimals: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onInput(event) {
      switch (this.type) {
        case 'number':
          {
            let value = event.target.value;
            if (this.allowDecimals) {
              // Allow decimals
              value = value.replace(/[^0-9.]/g, '') // Remove non-numeric characters except dots
              .replace(/(\..*)\./g, '$1') // Remove multiple dots
              .replace(/^0+(?=\.)|^(0+)(\d)/, '$2'); // Remove leading zeroes

              if (value.charAt(0) === '.') {
                value = '0' + value;
              }
            } else {
              // Disallow decimals
              value = value.replace(/[^0-9]/g, ''); // Remove all non-numeric characters
            }
            event.target.value = value;
            this.$emit('input', value);
            break;
          }
        default:
          this.$emit('input', event.target.value);
          break;
      }
    }
  }
};